import React from 'react';
import { hot } from 'react-hot-loader';
import Header from './Header/Header';
import Switcher from './Switcher';
import Footer from './Footer/Footer';
import s from '../index.scss';

const App = () => (
	<>
		<Header />
		<div id="main" className={s.main}>
			<Switcher />
		</div>
		<Footer />
	</>
);

export default hot(module)(App);
